module.exports = __webpack_public_path__ + "static/media/frnt.ee844e00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/frnt.jpg
// module id = 5756
// module chunks = 0